<script>
    import MyLayout from "@/layouts/layout.vue";
    //import { RouterLink, RouterView } from "vue-router";

    import { useloggedUserInfo } from "@/store/UserInfo";
    import GenerateLoanApplication from "@/views/crm/loanapplications/generateloanapplications.vue";
    import Videochat from "@/views/crm/shared/twilio/videochat/videochat.vue";
    import UploadDocument from "@/views/crm/loanapplications/uploaddocument.vue"
    import SignalRService from "@/service/crmservice/signalrservice"

    export default {
        components: {
            MyLayout,
            GenerateLoanApplication,
            Videochat,
            UploadDocument,
        },
        created() {
            this.userdata = localStorage.getItem("access_token");
            this.userId = localStorage.getItem("userId");
            this.hubConnection = this.signalRService.setupSignalR();
            this.signalRService.hubConnection = this.hubConnection
            this.startHub();
            this.reStartHub();
            const store = useloggedUserInfo();
            store.$reset();
            const favicon = document.getElementById("favicon");
            if (favicon != null) {
                favicon.href = localStorage.getItem("secondaryLogo");
            }
        },
        methods: {
            getConnectionId(userId) {
                //this.signalRService.GetConnectionId(userId).then(response => {
                //    this.connectionId = response.data.connnectionId;
                //    localStorage.setItem("connectionId", this.connectionId);
                //});
            },
            startHub() {
                this.hubConnection.start().catch(m => { }).then(m => {
                    this.getConnectionId(this.userId);
                });
            },
            reStartHub() {
                this.hubConnection.onreconnected(function (conntionId) {
                    this.getConnectionId(this.userId);
                });
            }
        },
        mounted() {
            this.useloggedUserInfo = useloggedUserInfo;
            this.currentPath = window.location.href;
            console.log("this.currentPath", this.currentPath);
        },
        data() {
            return {
                awesome: false,
                useloggedUserInfo,
                userdata: null,
                currentPath: window.location.href,
                signalRService: new SignalRService(),
                connectionId: null,
                hubConnection: null,
                userId: null
            };
        },
    };
</script>
<template>
    <section class="page-body">
        <!--<nav>
                <router-link to="/EmployeeAddEdit">Add Employee</router-link> |
                <router-link to="/">List Employee</router-link> |
            </nav>-->

        <template v-if="!currentPath.includes('/application') && !currentPath.includes('/videoChat') && !currentPath.includes('/uploadfiles')">
            <MyLayout v-if="userdata != null && userdata != ''" />
            <router-view v-if="userdata == null || userdata == ''" />
            <DialogsWrapper />
        </template>

        <!-- Show Loan Application Page -->

        <template v-if="currentPath.includes('/application')">
            <GenerateLoanApplication />
        </template>

        <!-- Show video Call Page -->

        <template v-if="currentPath.includes('/videoChat')">
            <div class="container">
                <Videochat />
            </div>
        </template>

        <!-- Upload Loan Document -->

        <template v-if="currentPath.includes('/uploadfiles')">
            <div class="uploadDocument">
                <div class="container">
                    <div class="center-page">
                        <UploadDocument />
                    </div>
                </div>
            </div>
        </template>


    </section>
</template>

<style>
    .uploadDocument {
        background: #b49859;
        border-color: #b49859;
        color: #ffffff;
    }

    .center-page {
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
